import { Component, Input } from '@angular/core';
import { ImageModule } from '@df/module-image/image.module';
import { DfUiModule } from '@df/ui/df-ui.module';
import { ModalConfig } from '@df/ui/modal/modal-config';
import { ModalLayoutLeftComponent } from './modal-layout-left.component';

export namespace NModalLayoutMiddle {
    /**
     * Default setup for left side modal
     */
    export const ModalConfig: ModalConfig = {
        hasBackdrop: true
    };
}

@Component({
    selector: 'modal-layout-middle',
    templateUrl: 'modal-layout-middle.html',
    styleUrls: ['modal-layout-middle.scss'],
    standalone: true,
    imports: [DfUiModule, ImageModule]
})
export class ModalLayoutMiddleComponent extends ModalLayoutLeftComponent {
    @Input()
    sideImage: string;
}
